import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionDetails, Stack, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

import { AccordionStyled } from './Accordion.styled';
import { AccordionSummaryStyled } from './AccordionSummary.styled';

interface AccordionItemProps extends PropsWithChildren {
  title: string;
  subtitle?: string;
  right?: React.ReactNode;
  isExpanded: boolean;
  totalRecommendations: number;
}

export const AccordionItem = ({
  title,
  subtitle,
  children,
  right,
  isExpanded,
  totalRecommendations,
}: AccordionItemProps) => {
  return (
    <AccordionStyled defaultExpanded={isExpanded} disableGutters elevation={0} disabled={!totalRecommendations}>
      <AccordionSummaryStyled
        expandIcon={totalRecommendations ? <ExpandMoreIcon sx={{ margin: 2 }} /> : null}
        aria-controls={`${title}-controls`}
        id={`${title}-header`}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: 'space-between',
            width: '100%',
            margin: 2,
          }}
        >
          <Stack>
            <Typography variant="subtitle1">{title}</Typography>
            {subtitle && <Typography variant="body2">{subtitle}</Typography>}
          </Stack>
          {right && right}
        </Stack>
      </AccordionSummaryStyled>
      <AccordionDetails>{children}</AccordionDetails>
    </AccordionStyled>
  );
};
